import { createContext, use, type ReactNode } from 'react';

/**
 * Carries the desktop stats-bar element from the find-and-fix route into MapView,
 * so the bar renders above the map only and every right-hand panel (Layers /
 * Filters / Download / POI / Stats config) sits full-height beside it.
 *
 * Null on SAVI and mobile (no provider) → MapView renders nothing in the slot.
 */
const StatsBarSlotContext = createContext<ReactNode>(null);

export const StatsBarSlotProvider = StatsBarSlotContext.Provider;

export const useStatsBarSlot = () => use(StatsBarSlotContext);
